
<div class="col-lg-12">
  
  <div class="card" style="width:49%;float:left;height:620px;">

        <h3 class="heading2" id="titleXL" style="margin:60px 60px 60px 60px !important;">
          Download the result

        </h3>
        
        <div id="complete" style="color:#2c973e !important;margin:20px 60px 80px 60px !important;font-size:16px;">
          <img src="./assets/static/icon-green-tick.png" />
          &nbsp;&nbsp;&nbsp; Prediction complete
        </div>
        
        <!-- <a href="../../../../../Python/CA_General/CA_General/test_output/predictedFile_admin.xlsm" download style="margin: 40px 60px 40px 60px !important;">
          
          <button id="download" class="btn btn-lg btn-primary buttonStyle">
            Download Excel file

          </button>
          
        </a> -->
      <div class="center">
        <a class="btn btn-lg btn-primary buttonStyle" (click)="DownloadPredict()"
        style="margin: 40px 60px 40px 60px !important;">Download</a>
      </div>
        
        <div class="center">
                
          <button type="button" (click)="OpenexcelLogsDialog()" class="btn btn-lg btn-primary buttonStyle" 
              style="margin:30px 60px 30px 60px !important;"  >
              Get Logs
          </button>
      
      </div>
  </div>
  
  <div class="card" style="width:49%;float:right;height:620px;">
    
    <h3 class="heading2" style="margin:60px 60px 40px 60px !important;">Instant Prediction</h3>
    
    <form #form1="ngForm" (submit)="onInstant();form1.reset()">
      
      <input type="text" id="desc" name="desc" placeholder="Enter a Description here" [(ngModel)]="predictDesc"
        style="margin:0 60px 30px 60px !important;padding:15px;width:476px;height:60px;max-width:none !important;
        border:2px solid #e3e3e3 !important;" />
      
      <div class="center">
        <!-- <input type="submit" value="INSTANT PREDICT" class="submit" style="background-color:#808080;border:none;text-align:center;font-size:16px !important;" /> -->
        <button type="submit" class="btn btn-lg btn-primary buttonStyle" style="margin:30px 60px 30px 60px !important;">
            Instant Predict
          </button>
      </div>
          
        
          
      <br /><br /><br />
    </form>
    <div class="center">
                
      <button type="button" *ngIf="enableGetLogs" (click)="OpenLogsDialog()" class="btn btn-lg btn-primary buttonStyle" 
          style="margin:30px 60px 30px 60px !important;"  >
          Get Logs
      </button>
  
  </div>
  </div>

</div>